import { useMemo } from 'react';

export const useSessionType = ( distributionType ) => {
  const { isEnterprise, isNow, isStudio } = useMemo(
    () => ( {
      isEnterprise: distributionType === 'enterprise',
      isNow: distributionType === 'now',
      isStudio: distributionType === 'studio',
    } ),
    [distributionType],
  );
  const distributionName = useMemo( () => {
    if ( isNow ) return 'Now';
    if ( isStudio ) return 'Studio';
    if ( isEnterprise ) return 'Advanced';
    return '';
  }, [isEnterprise, isNow, isStudio] );

  return {
    isEnterprise,
    isNow,
    isStudio,
    distributionName,
  };
};
